import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { ComputingTrait } from "./computing-traits/computing-trait";
import { v4 as uuidv4 } from "uuid";

export class Request implements RequestModelInterface
{
    public requestId: string;

    public constructor(
        public drugId: string,
        public drugModelId: string,
        public computingTrait: ComputingTrait,
    )
    {
        this.requestId = uuidv4();
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("request");

        element.appendNewElement("requestId", this.requestId);
        element.appendNewElement("drugId", this.drugId);
        element.appendNewElement("drugModelId", this.drugModelId);

        element.append(this.computingTrait.getXml(doc));

        return element;
    }
}
